import AppSettingController from "../../../Main/controller/AppSettingController";
import {useTranslation} from "react-i18next";

export default function ToggleActiveDesk() {
    const {t} = useTranslation();
    const setting = AppSettingController.getSetting();

    return (
        <div className={"dark-mode"}>
            <p>{t("setting.deskActivate")}</p>
            <div className={"dark-mode-toggle"}>
                <label className="switch">
                    <input type="checkbox" checked={setting.activeDesk} onChange={() => AppSettingController.toggleActiveDesk()}/>
                    <span className="slider round"></span>
                </label>
            </div>
        </div>
    )
}